import React from 'react';
import { Sheet } from 'records/Sheet';
import { SheetVersion } from 'records/SheetVersion';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';

interface FuncParams {
  selected: boolean;
  handlePageSelectChange: (sheet: Sheet) => void;
}

interface Props extends WithAppStoreProps {
  sheet: Sheet;
  children: (funcParams: FuncParams) => React.ReactNode;
}

class SelectedSheet extends React.Component<Props> {
  handlePageSelectChange = (sheet: Sheet): void => {
    const { appState, actions } = this.props;
    const { selectedPages } = appState;
    const { pageid } = sheet.versions.last<SheetVersion>();

    const updatedSelectedPages = selectedPages.has(pageid)
      ? selectedPages.delete(pageid)
      : selectedPages.add(pageid);

    actions.setSelectedPages(updatedSelectedPages);
  };

  render(): React.ReactNode {
    const { appState, sheet } = this.props;
    const { selectedPages } = appState;
    const latestSheetVersion = sheet.versions.last<SheetVersion>();

    const selected = selectedPages.has(latestSheetVersion.pageid);
    const { children } = this.props;

    return children({
      selected,
      handlePageSelectChange: this.handlePageSelectChange,
    });
  }
}

export default withAppStore<Props>(SelectedSheet);
